/**
 * Sidebar entries the identity feature contributes. Permissions are the
 * canonical strings from openapi/generated/route_policy.gen.go.
 */
import { ShieldCheck, Users } from "lucide-react";

import type { NavEntry } from "@/app-shell/route-registry";

export const identityNavEntries: NavEntry[] = [
  {
    path: "/admin/users",
    labelKey: "identity.nav.users",
    icon: Users,
    permission: "platform.user.read",
  },
  {
    path: "/admin/roles",
    labelKey: "identity.nav.roles",
    icon: ShieldCheck,
    permission: "platform.role.read",
  },
];
